{
  "familyId": "TAA-LEZEN-VERB",
  "questions": [
    {
      "id": "TAA-LEZEN-VERB-001",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een tegenstelling aan in deze zin? 'Het was druk, maar de sfeer bleef goed.'",
      "options": ["maar", "want", "dus", "ook"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden voor tegenstelling",
            "content": "Tegenstellingssignaalwoorden: maar, toch, echter, hoewel, daarentegen. Ze introduceren iets dat je niet verwacht na de eerste zin.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_tegenstelling_signaal",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Maar' is een signaalwoord voor tegenstelling. Het introduceert iets onverwachts: het was druk (verwachting: slechte sfeer), maar de sfeer bleef goed (onverwacht).",
        "solutionSteps": [
          "Zoek het signaalwoord in de zin: 'maar'",
          "'Maar' introduceert iets onverwachts",
          "Tegenstelling-signaalwoorden: maar, toch, echter, hoewel"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Maar' is een signaalwoord voor tegenstelling.",
          "1": "Je dacht waarschijnlijk dat 'want' een tegenstelling is. Maar 'want' geeft een oorzaak of reden aan (waarom?). Onthoud: tegenstelling = maar, toch, echter.",
          "2": "Je dacht waarschijnlijk dat 'dus' een tegenstelling is. Maar 'dus' geeft een gevolg aan (wat is het resultaat?). Onthoud: gevolg = dus, daarom.",
          "3": "Je dacht waarschijnlijk dat 'ook' een tegenstelling is. Maar 'ook' geeft een toevoeging aan (wat komt erbij?). Onthoud: toevoeging = ook, bovendien."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERB-002",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "multiple_choice",
      "question": "Welk tekstverband is er tussen deze twee zinnen?",
      "options": ["tegenstelling", "oorzaak-gevolg", "opsomming", "tijdsvolgorde"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "Het was prachtig weer buiten. Toch besloot Lisa binnen te blijven om te studeren.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tekstverbanden herkennen",
            "content": "Het signaalwoord 'toch' geeft een tegenstelling aan. Je verwacht dat Lisa naar buiten gaat (mooi weer), maar ze doet het tegenovergestelde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_tegenstelling_herkennen",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het signaalwoord 'toch' wijst op een tegenstelling. Verwachting: mooi weer → naar buiten. Werkelijkheid: toch binnen studeren.",
        "solutionSteps": [
          "Zoek het signaalwoord: 'toch'",
          "'Toch' = tegenstelling",
          "Verwachting: mooi weer → naar buiten",
          "Werkelijkheid: toch binnen studeren → tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Toch' is een signaalwoord voor tegenstelling.",
          "1": "Je dacht waarschijnlijk dat dit oorzaak-gevolg is. Maar bij oorzaak-gevolg veroorzaakt de ene zin de andere. Hier is het juist onverwacht. Onthoud: oorzaak-gevolg = dus, daarom, daardoor.",
          "2": "Je dacht waarschijnlijk dat dit een opsomming is. Maar bij opsomming worden gelijksoortige dingen opgesomd. Hier worden tegengestelde dingen beschreven. Onthoud: opsomming = ook, bovendien, ten eerste.",
          "3": "Je dacht waarschijnlijk dat dit tijdsvolgorde is. Maar bij tijdsvolgorde volgen gebeurtenissen elkaar op in de tijd. Het signaalwoord 'toch' wijst op tegenstelling. Onthoud: tijdsvolgorde = daarna, vervolgens."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERB-003",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "multiple_choice",
      "question": "Welk tekstverband is er tussen deze twee zinnen?",
      "options": ["oorzaak-gevolg", "tegenstelling", "vergelijking", "opsomming"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "De temperatuur daalde flink. Daardoor bevroor het water in de sloten.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oorzaak-gevolg herkennen",
            "content": "Het signaalwoord 'daardoor' geeft een oorzaak-gevolg verband aan. Oorzaak: de temperatuur daalde. Gevolg: het water bevroor.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_oorzaak_gevolg",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Daardoor' is een signaalwoord voor oorzaak-gevolg. Oorzaak: de temperatuur daalde flink. Gevolg: het water bevroor.",
        "solutionSteps": [
          "Zoek het signaalwoord: 'daardoor'",
          "'Daardoor' = oorzaak-gevolg",
          "Oorzaak: de temperatuur daalde",
          "Gevolg: het water bevroor"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daardoor' geeft oorzaak-gevolg aan.",
          "1": "Je dacht waarschijnlijk dat dit een tegenstelling is. Maar bij een tegenstelling verwacht je het tegenovergestelde. Hier is het een logisch gevolg: kou → bevriezing. Onthoud: tegenstelling = maar, toch, echter.",
          "2": "Je dacht waarschijnlijk dat dit een vergelijking is. Maar bij vergelijking worden twee dingen vergeleken. Hier veroorzaakt de ene zin de andere. Onthoud: vergelijking = net als, evenals, terwijl.",
          "3": "Je dacht waarschijnlijk dat dit een opsomming is. Maar bij opsomming worden gelijksoortige dingen opgesomd. Hier is er een causaal verband. Onthoud: opsomming = ook, bovendien, ten eerste."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERB-004",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "multiple_choice",
      "question": "Welk tekstverband past bij het signaalwoord 'bovendien'?",
      "options": ["opsomming", "tegenstelling", "oorzaak-gevolg", "tijdsvolgorde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden per verband",
            "content": "Opsomming: bovendien, ook, daarnaast, ten eerste. Tegenstelling: maar, toch, echter. Oorzaak-gevolg: daardoor, dus, want. Tijdsvolgorde: daarna, vervolgens, ten slotte.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_opsomming_signaal",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Bovendien' voegt informatie toe aan wat er al gezegd is. Dit is een opsommingssignaalwoord. Voorbeeld: 'Het regent. Bovendien waait het hard.' (twee dingen worden opgesomd).",
        "solutionSteps": [
          "'Bovendien' = er komt iets bij",
          "Iets toevoegen = opsomming",
          "Andere opsommingswoorden: ook, daarnaast, ten eerste"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Bovendien' is een opsommingssignaalwoord — het voegt informatie toe.",
          "1": "Je dacht waarschijnlijk aan tegenstelling. Maar 'bovendien' voegt iets toe, het stelt niets tegenover. Onthoud: tegenstelling = maar, toch, echter.",
          "2": "Je dacht waarschijnlijk aan oorzaak-gevolg. Maar 'bovendien' geeft geen oorzaak of gevolg aan. Onthoud: oorzaak-gevolg = daardoor, dus, want.",
          "3": "Je dacht waarschijnlijk aan tijdsvolgorde. Maar 'bovendien' zegt niets over tijd. Onthoud: tijdsvolgorde = daarna, vervolgens, ten slotte."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERB-005",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "matching",
      "question": "Koppel elk signaalwoord aan het juiste tekstverband.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["daardoor", "maar", "bovendien", "daarna"],
        "rightItems": ["tegenstelling", "oorzaak-gevolg", "tijdsvolgorde", "opsomming"],
        "correctMatches": {"0": 1, "1": 0, "2": 3, "3": 2}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden koppelen",
            "content": "Daardoor = oorzaak-gevolg. Maar = tegenstelling. Bovendien = opsomming. Daarna = tijdsvolgorde. Maak een voorbeeldzin om het verband te herkennen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_signaalwoorden_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Daardoor → oorzaak-gevolg. Maar → tegenstelling. Bovendien → opsomming. Daarna → tijdsvolgorde.",
        "solutionSteps": [
          "Daardoor: iets veroorzaakt iets anders → oorzaak-gevolg",
          "Maar: iets onverwachts → tegenstelling",
          "Bovendien: er komt iets bij → opsomming",
          "Daarna: later in de tijd → tijdsvolgorde"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-VERB-006",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "text_highlight",
      "question": "Markeer het signaalwoord dat een tegenstelling aangeeft.",
      "data": {
        "text": "De film was lang. Toch vond iedereen het een spannend verhaal.",
        "correctHighlights": [{ "start": 19, "end": 23 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden tegenstelling",
            "content": "Tegenstellingssignaalwoorden: maar, toch, echter, hoewel, daarentegen. Ze introduceren iets onverwachts.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_tegenstelling_highlight",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Toch' is het signaalwoord voor tegenstelling. De film was lang (verwachting: saai), toch vond iedereen het spannend (onverwacht).",
        "solutionSteps": [
          "Zoek het woord dat een onverwachte wending aangeeft",
          "'Toch' introduceert iets onverwachts → tegenstelling",
          "Andere tegenstellingswoorden: maar, echter, hoewel"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-VERB-007",
      "familyId": "TAA-LEZEN-VERB",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verbanden",
      "questionType": "text_highlight",
      "question": "Markeer het signaalwoord dat een oorzaak-gevolgverband aangeeft.",
      "data": {
        "text": "Het had de hele nacht geregend. Daardoor stonden de weilanden onder water.",
        "correctHighlights": [{ "start": 36, "end": 44 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoorden oorzaak-gevolg",
            "content": "Oorzaak-gevolgsignaalwoorden: daardoor, daarom, dus, hierdoor, waardoor, doordat. Ze geven aan dat het ene het gevolg is van het andere.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verband_oorzaak_gevolg_highlight",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Daardoor' is het signaalwoord voor oorzaak-gevolg. De regen (oorzaak) → weilanden onder water (gevolg). 'Daardoor' verbindt oorzaak en gevolg.",
        "solutionSteps": [
          "Zoek het woord dat oorzaak en gevolg verbindt",
          "'Daardoor' = door dat (verwijst naar de oorzaak)",
          "Andere oorzaak-gevolgwoorden: daarom, dus, hierdoor"
        ]
      }
    }
  ]
}